import React, { useEffect } from 'react'
import { useTranslate, useRecordContext } from 'react-admin'
import {  Typography, Box } from '@mui/material'
import {  hasPermissionFunction } from 'src/helper/HasPermission'
import { CompleteSideCard, ShowCard } from 'src/components/uiElements/cards/ShowCard'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import { PERMISSION_EXCHANGE_RATE } from 'src/helper/Permission'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
interface CurrencyToShow {
  [key: string]: number // ex: EUR : 0.32
}

interface Liquidation {
  taxes_amount: number | null
  comision: number | null
  currency_by_work_unit: any // The actual type is not provided in the input data.
  fare_amount: number | null
  iva: number | null
  currency_by_business_unit: any // The actual type is not provided in the input data.
  over_amount: number | null
  expenses: number | null
  currency_to_show: CurrencyToShow // The actual type is not provided in the input data.
  commission_percentage: number | null
  net_agency: number | null
  additional_fare: number | null
  net_price: number
  liquidation_supplier: Liquidation | null
  id: number
  currency_origin: string
  final_price: number
  liquidation_retail: Liquidation | null
  item_id: number
  commission_paid: number | null
  markup: number | null
  liquidation_wholesaler: Liquidation | null
  fee: number
  rules: any
  sale_discount: number | null
  taxes_1: number | null
  taxes_2: number | null
  taxes_3: number | null
}

interface RequestRule {
  token_workunit: string
  token_product: string
  rules_parameters: {
    product_type: string
    checkin: string
    destination_type: number
    item_id: number
    rule_type: string
    rule_liquidation_type: string
  }
  data: object | null // The actual type is not provided in the input data.
}

interface LiquidationBase {
  message: string
  messsageArg: string
  liquidation: Liquidation
  requestRule: RequestRule
}

interface LiquidationSupplier extends LiquidationBase {}
interface LiquidationRetail extends LiquidationBase {}
interface LiquidationWholesaler extends LiquidationBase {}

interface Pricing {
  taxes_amount: number | null
  comision: number | null
  currency_by_work_unit: object | null
  fare_amount: number | null
  iva: number | null
  currency_by_business_unit: object | null
  over_amount: number | null
  expenses: number | null
  currency_to_show: object | null
  commission_percentage: number | null
  net_agency: number | null
  additional_fare: number | null
  net_price: number
  liquidation_supplier: LiquidationSupplier | null
  id: number
  currency_origin: string
  currency: string
  final_price: number
  liquidation_retail: LiquidationRetail | null
  item_id: number
  commission_paid: number | null
  markup: number | null
  liquidation_wholesaler: LiquidationWholesaler | null
  fee: number
  sale_discount: number | null
  taxes_1: number | null
  taxes_2: number | null
  taxes_3: number | null
}


interface ExchangeTypeProps {
  setIndividualRecord: React.Dispatch<React.SetStateAction<object>>
}

const validObject = (object: object | null) => {
  if (object && typeof object == 'object' && Object.keys(object).length > 0) {
    return true
  }
  return false
}

const getExchangeType = (pricing: Pricing[]): JSX.Element | null => {
  try {
    if (validObject(pricing?.[0])) {
      const currency_to_show: CurrencyToShow | null = pricing[0]?.currency_to_show as CurrencyToShow | null
      const currency_origin = pricing[0]?.currency_origin
      const currency = pricing[0]?.currency
      const value_of_currency_origin = currency_to_show?.[currency_origin]
      if (!currency || !currency_origin) {
        return null
      }
      // get the reverse exchange rate
      if (currency == currency_origin){
        return null
      }
      if (value_of_currency_origin) {
        return (
          <Typography component='span' fontWeight='bold'>
            {`${currency} - ${currency_origin} : ${numberFormatterWithDecimalAndThousand(1 / value_of_currency_origin,4)}`}
          </Typography>
        )
      }
      return null
    }
    return null
  } catch (error) {
    return null
  }
}

export const ExchangeType: React.FC<ExchangeTypeProps> = ({ setIndividualRecord }) => {
  const translate = useTranslate()
  const record = useRecordContext()

  useEffect(() => {
    if (record) {
      setIndividualRecord && setIndividualRecord(record)
    }
  }, [record, setIndividualRecord])

   const exchangeTypeElement = getExchangeType(record?.pricing_relation)

  return (
    <>
      {hasPermissionFunction('pricing', PERMISSION_EXCHANGE_RATE) && exchangeTypeElement && (
        <ShowCard
          iconHeader={<CurrencyExchangeIcon />}
          title={translate('ra.title.exchange_type')}
          variant='text'
          optionHeigth={'liquidation'}
          className={undefined}
          posTitle={undefined}
          preActionButton={undefined}
          actionButtonText={undefined}
          actionButtonColor={undefined}
          actionButtonStartIcon={undefined}
          actionButtonIcon={undefined}
          onClickButton={undefined}
          contentStyle={undefined}
          cardStyle={undefined}
        >
          <CompleteSideCard style={undefined}>
            <Box>{exchangeTypeElement}</Box>
          </CompleteSideCard>
        </ShowCard>
      )}
    </>
  )
}
